module.exports = __webpack_public_path__ + "workspace/static/img/horizontal-bar-chart.dd8146c.svg";